import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const PenIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.58468 10.5943L5.40953 13.4172L13.0607 5.77144L10.2472 2.93715L2.58468 10.5943ZM0 16L4.41455 14.4114L1.60113 11.6229L0 16ZM14.0099 0C13.461 0 12.9577 0.228571 12.5918 0.582857L10.9449 2.22857L13.7697 5.05143L15.4166 3.40571C15.7826 3.04 15.9999 2.54857 15.9999 1.98857C16.0113 0.902857 15.1193 0 14.0099 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default PenIcon;
